import { Search } from 'ui/components/Search'

import { useAdverseMediaListContext } from '../../context/AdverseMediaListContext'

export const Actions = () => {
  const { navigate, state } = useAdverseMediaListContext()

  return (
    <Search
      onSearch={(value) => navigate({ ...state, page: 1, searchCase: value })}
      value={state.searchCase}
      placeholder="Search"
    />
  )
}
